// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

import { BaseLeaderboardEntity, LeaderboardRow, LeaderboardConfig } from './leaderboard.entity';
import { ECOSYSTEM_INFLUENCE_LEADERBOARD_MOCK_DATA } from '../mocks/ecosystem-influence-leaderboard.mock';

/**
 * Ecosystem Influence Leaderboard Entity (v2)
 *
 * Provides configuration for the Ecosystem Influence Leaderboard.
 * This entity extends the base leaderboard with ecosystem-specific configuration.
 */
export class EcosystemInfluenceLeaderboardEntity extends BaseLeaderboardEntity {
  /**
   * Title for the Ecosystem Influence Leaderboard
   */
  static readonly TITLE = 'Ecosystem Influence Leaderboard';

  /**
   * Default time range type for API calls
   */
  static readonly DEFAULT_TIME_RANGE_TYPE = 'last_2_years';

  /**
   * Get the configuration for the Ecosystem Influence Leaderboard
   */
  static getConfig(): LeaderboardConfig {
    return {
      title: this.TITLE,
      columns: this.COLUMNS
    };
  }

  /**
   * Get mock data for Ecosystem Influence Leaderboard
   * Mock data is stored in a separate file for better maintainability
   */
  static getMockData(): LeaderboardRow[] {
    return ECOSYSTEM_INFLUENCE_LEADERBOARD_MOCK_DATA;
  }
}
